const routes = [
  {
    path: '/student',
    component: () => import('../student/mainPage.vue'),

    children: [
      {
        name: 'student.dashboard',
        path: '',
        component: () => import('../student/dashboard/Dashboard.vue'),
      },

      {
        name: 'student.profile',
        path: 'profile',
        component: () => import('../student/profile/profileReport.vue'),
      },

      {
        name: 'student.browse.class.report',
        path: 'browse/class/report',
        component: () => import('../student/browseClasses/browseClassesReport.vue'),
      },
      {
        name: 'student.browse.class.preview',
        path: 'browse/class/preview/:id',
        component: () => import('../student/browseClasses/BrowseClassDetails.vue'),
      },
      {
        name: 'student.class.watch.preview',
        path: 'browse/class/watch/:slug/:id',
        component: () => import('../student/browseClasses/BrowseClassWatchPreview.vue'),
      },
      {
        name: 'student.myClass',
        path: 'myclass',
        component: () => import('../student/myClass/myClassReport.vue'),
      },
      {
        name: 'student.ticket.report',
        path: 'ticket/report',
        component: () => import('../student/tickets/support_report.vue'),
      },
      {
        name: 'student.profileedit',
        path: 'profile/edit',
        component: () => import('../student/profile/editprofile'),
      },
    ],
  },
];
export default routes;
